import * as ts from "../common/Translator";
import {translate, translateId, translateNaMaText, translateTitledId} from "../common/Translator";
import * as KeyboardKeyCode from "../constants/KeyboardKeyCode";
import {isKeyEventForBusinessFunction} from "../common/ShortCutsUtil";
import * as BusinessFunction from "../constants/BusinessFunction";
import {
    addWait,
    ajaxJSONWithoutError,
    ajaxJSONWithoutWait,
    busy,
    fieldValue,
    getFirstNotEmptyObj,
    isAnyEqualToFirst,
    isNotEmptyOrNull,
    isNullOrUndefined,
    namaCompare,
    nextId,
    removeWait,
    setFieldValue,
    substringBefore
} from "../common/NamaCommon";
import {BaseWidget, fetchAndApplyStyle} from "../widgets/BaseWidget";
import {findFieldMetadata} from "../common/Metadata";
import {columnEditor, columnTemplate, dataItemSetterCallback} from "./GridGetterAndSetterCallbacks";
import {
    fetchFilteringUIFor,
    fillFilterOperatorsForField,
    gridExcelExport,
    gridRowNumberColumn,
    namaTypeToKendoColumnType,
    resizePagerToShowPageSize,
    startFilter,
    startGrouping,
    toNormalId
} from "../views/list/ListViewColumns";
import {gridSizeToPixels, isMobileDevice} from "../common/GUIUtilities";
import {userCanNOTCopyLine, userCanNOTInsertOrDeleteLine, userCanSearch, userCanViewField} from "../login/Security";
import * as ClientCache from "../login/ClientCache";
import {
    getCustomGUISettings,
    getGridPageSize,
    isFeatureEnabled,
    nextGUIDId,
    shouldShowHelpMsgs,
    shouldUseDetailedGridsInMobile,
    showFieldInfoFor,
    showTooltip_
} from "../login/ClientCache";
import * as BaseDispatcher from "../actions/BaseDispatcher";
import {disableColumnsIfNeeded, performPostAction} from "../actions/BaseDispatcher";
import {
    copyLinesAction,
    deleteRow,
    fetchGridCurrentDataItem,
    gridFocusCell,
    letterORNumberKeyPressed,
    openGridLineEditor,
    realLineKeys,
    removeEditorPart,
    showMultiCopyDialog
} from "../grid/GridEventsController";
import * as ApplicableWhen from '../constants/ApplicableWhen'
import * as GridAction from "../constants/GridAction";
import {isInNewMode} from '../views/edit/EditScreenToolbar'
import * as NamaURLS from "../constants/NamaURLS";
import {PopupQuickCreator} from "../views/edit/PopupQuickCreator";
import {bindClickOnSelectAll, fetchSelectorPopupPreferences, ReferenceSelectorPopup, updateCheckBoxes} from '../views/search/SearcherWindow'
import * as FieldType from "../constants/FieldType";
import * as types from "../constants/FieldType";
import {comboColumnEditor, comboTemplate} from "./GridCell_Combo";
import {calcReferenceEntityType, createQuickCreateContextInfo, ReferenceWidget} from "../widgets/ReferenceWidget";
import {appendRow} from "./GridEventsController";
import {fetchFieldTooltip, showTooltip} from "../common/TooltipUtil";
import GridToolbarTemplate from "../compiled-templates/GridToolbarTemplate";
import {
    getColAggregates_,
    getColHidden,
    getColLocked,
    getColOrder,
    getColWidth,
    reorderColumns,
    setColAggregates_,
    setColHidden,
    setColLocked,
    setColWidth
} from "../views/StorageUtil";
import {shouldShowImage} from "../common/AttachmentLinkUtil";
import * as ShowImageIn from "../constants/ShowImageIn";
import {imgColumnTemplate} from "./GridCell_Reference";
import {toCSVLineWithSep} from "../common/StringUtils";
import {CustomItemSearcherWindow} from "../views/search/CustomItemSearcherWindow";
import {gridKey, NamaGridLineEditor} from "./NamaGridLineEditor";
import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import {defaultCriteriaForFilterField} from "../views/list/CriteriaFromFilterField";
import {QuestionListWidget} from "../widgets/QuestionListWidget";
import * as notifier from "../common/ErrorsNotification";
import {findHelpMsgAndShowIt} from "../common/ErrorsNotification";
import moment from "moment/moment";
import * as Formats from "../constants/Formats";
import {prepareTimeVal} from "../widgets/TimeFieldWidget";
import {setItemCollapseAttr} from "../views/edit/EditScreenGroup";
import * as CommonConstants from "../constants/CommonConstants";

let unifiedRefWidth = "10em";

export function shouldApplyNewSearchUI(entityType) {
    return entityType === "InvItem" && getCustomGUISettings().itemLevels.length > 0;
}

function showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, preferences, extraCriteria, columnId, fromQuestionList) {
    new ReferenceSelectorPopup({
        owner: owner,
        entityType: entityType,
        refSelectedCallBack: callBack,
        contextInfo: contextInfo
        , inChangeDimsDialog: inChangeDimsDialog,
        defaultCriteria: defaultCriteria,
        preferences: preferences,
        extraCriteria: extraCriteria,
        srcColumnId: columnId,
        fromQuestionList: fromQuestionList
    }).showPopup();
}

export function createSearcherWindow(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, extraCriteria, columnId, fromQuestionList) {
    let newSearchUI = localStorage.getItem("newSearchUI");
    if (shouldApplyNewSearchUI(entityType) && isNotEmptyOrNull(newSearchUI)) {
        new CustomItemSearcherWindow({
            owner: owner,
            entityType: entityType,
            refSelectedCallBack: callBack,
            contextInfo: contextInfo
            , inChangeDimsDialog: inChangeDimsDialog,
            defaultCriteria: defaultCriteria,
            extraCriteria: extraCriteria
        }).showPopup();
        return;
    }
    if (owner._selectorPopupPreferences) {
        showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, owner._selectorPopupPreferences, extraCriteria, columnId, fromQuestionList);
        return;
    }
    fetchSelectorPopupPreferences(entityType, (preferences) => {
        owner._selectorPopupPreferences = preferences;
        showNormalSelector(owner, entityType, callBack, contextInfo, inChangeDimsDialog, defaultCriteria, preferences, extraCriteria, columnId, fromQuestionList);
    });

}

function unifiedWidthInEM() {
    return unifiedRefWidth.substring(0, unifiedRefWidth.length - 2);
}

function isReferenceColumn(columnMetadata) {
    return columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference;
}

export function gridGroupFooterTemp(fieldID, suffix, owner, metaData) {
    return (data) => {
        let temp = "";
        let colAggregates_ = getColAggregates_(owner, fieldID);
        if (!colAggregates_)
            return temp;
        let modelId_ = modelId(fieldID);
        let aggrs = colAggregates_.split(",");
        if (!suffix)
            suffix = "";
        for (let aggr of aggrs) {
            if (!data[modelId_ + suffix])
                continue;
            let aggrFunVal = data[modelId_ + suffix][aggr.toLowerCase()];
            if (!aggrFunVal)
                continue;
            if (aggr.toLowerCase() == "min" || aggr.toLowerCase() == "max") {
                let columnMetadata = findFieldMetadata(fieldID, metaData);
                if (columnMetadata.fieldType === FieldType.Date || columnMetadata.fieldType === FieldType.DateAndTime) {
                    let date = new moment(aggrFunVal, Formats.DATE_MOMENT_SERVER_FORMAT);
                    aggrFunVal = date.format(Formats.DATE_MOMENT_SERVER_FORMAT)
                }
                if (columnMetadata.fieldType === FieldType.Time) {
                    aggrFunVal = prepareTimeVal(aggrFunVal);
                }
            }
            temp += `, ${aggr}: ${aggrFunVal} `;
        }
        temp = temp.substr(1, temp.length);
        return temp;
    }
}

function updateGridColumnsInOptions(grid, field, colAggregates) {
    if (!grid)
        return;
    let allColumns = grid.getOptions().columns.flatMap(c => c.columns ? c.columns : c);
    let col = allColumns.filter(c => c.field === field)[0];
    if (!colAggregates)
        col.aggregates = [];
    else
        col.aggregates = colAggregates;
}

function updateGroupingDataAndReGroup(grid, field, owner, colAggregates) {
    if (!grid || !field)
        return;
    let relatedField = null;
    let columnMetadata = findFieldMetadata(toNormalId(field), owner.metaData)
    if (columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference) {
        relatedField = field + "$code";
    }
    let groupingData = grid.dataSource.group();
    if (!groupingData)
        return;
    for (let gData of groupingData) {
        let aggregatesToAdd = gData.aggregates.filter(g => g.field !== field);
        if (relatedField)
            aggregatesToAdd = gData.aggregates.filter(g => g.field !== relatedField);
        if (colAggregates) {
            for (let aggr of colAggregates) {
                aggregatesToAdd.push({field: field, aggregate: aggr});
                if (relatedField)
                    aggregatesToAdd.push({field: relatedField, aggregate: aggr});
            }
        }
        gData.aggregates = aggregatesToAdd;
    }
    grid.dataSource.group(groupingData);
}

export function fetchColId(col) {
    let idOfGroupedCol = col.id;
    if (col.hidden && col.id.endsWith(".code"))
        idOfGroupedCol = substringBefore(col.id, ".code");
    return idOfGroupedCol;
}

function updateAggregatesStatus(field, aggregates, owner) {
    let colAggregates_ = getColAggregates_(owner, toNormalId(field));
    if (colAggregates_) {
        let currentAggr = colAggregates_.split(",");
        for (let aggr of currentAggr) {
            aggregates.filter(a => a.text === aggr).forEach(a => a.selected = true);
        }
    }
}

function setColAggregates(selectedItem, field, container, owner, columns, suffix, grid) {

    if (selectedItem.hasClass("k-selected"))
        selectedItem.removeClass("k-selected");
    else
        selectedItem.addClass("k-selected");
    let colAggregates = [];
    let selectedElems = selectedItem.parent().find(".nama-aggregate-item.k-selected");
    for (let elem of selectedElems) {
        if (!colAggregates.contains($(elem).attr("data-aggregate-func")))
            colAggregates.push($(elem).attr("data-aggregate-func"))
    }
    setColAggregates_(owner, toNormalId(field), toCSVLineWithSep(",", colAggregates));
    colAggregates = colAggregates.map(aggr => aggr.toLowerCase());
    updateGridColumnsInOptions(grid, field, colAggregates);
    updateDataSrcAggregates(grid.columns, grid.dataSource, owner);
    updateGroupingDataAndReGroup(grid, field, owner, colAggregates);
}

function notAllowedAggregate(aggregate, fieldMetaData) {
    if (isAnyEqualToFirst(fieldMetaData.fieldType, FieldType.Reference, FieldType.Genericreference
        , FieldType.EntityType, FieldType.BigText, FieldType.Boolean, FieldType.Text, FieldType.Enum))
        return isAnyEqualToFirst(aggregate, "Min", "Max", "Average", "Sum");
    return false;
}

let aggregatesFunctions = ["Count", "Min", "Max", "Average", "Sum"];
let aggregatesIcons = {Count: "fa-tally", Min: "fa-less-than", Max: "fa-greater-than", Average: "fa-arrows-repeat-1", Sum: "fa-sigma"};

function changePopupMenuNestedColText(e, columns) {
    let list = e.container.find(".k-columns-item").find("label");
    list.each(function (e) {
        let span = $(this).find("span");
        let input = $(this).find("input");
        let colId = input.attr("data-field");
        let column = columns.flatMap(c => c.columns ? c.columns : c).filter(c => c.field == colId)[0];
        if (column && column.attributes && column.attributes["fullTitle"])
            span[0].textContent = column.attributes["fullTitle"].replaceAll("|", " - ");
    });
}

export function colMenuBuilder(e, that, columns, gridInEditView, suffix, grid) {
    let field = e.field;
    let fieldMetaData = findFieldMetadata(toNormalId(e.field), that.metaData);
    fillFilterOperatorsForField(e.container.find("select"), fieldMetaData, that.owner.entityType);
    let container = e.container;
    let popup = container.data('kendoPopup');
    let aggregateItems = [];
    if (!fieldMetaData) {
        aggregateItems.push({value: "Count", text: "Count", icon: aggregatesIcons["Count"]});
    } else {
        for (let aggregateFun of aggregatesFunctions) {
            if (notAllowedAggregate(aggregateFun, fieldMetaData))
                continue;
            aggregateItems.push({value: aggregateFun, text: aggregateFun, icon: aggregatesIcons[aggregateFun]});
        }
    }
    let aggregatesDiv = $("<div class='k-columnmenu-item-wrapper'><div class='nama-aggregates '></div></div>");

    updateAggregatesStatus(field, aggregateItems, that.owner);
    for (let aggregateItem of aggregateItems) {
        aggregatesDiv.find(".nama-aggregates").append(
            `<div data-aggregate-func="${aggregateItem.value}" class="nama-aggregate-item k-columnmenu-item ${aggregateItem.selected ? "k-selected" : ""}" tabindex="0">
                <i class="px-3 fa-solid ${aggregateItem.icon}"></i><span>${aggregateItem.text}</span>
            </div>`)
    }
    aggregatesDiv.appendTo(container);
    aggregatesDiv.find(".nama-aggregates").kendoExpansionPanel({
        title: 'Aggregates',
        // subTitle: 'South America',
    });
    aggregatesDiv.find(".nama-aggregates .k-expander-title").html(`<i class="fa-solid fa-function"></i><span class="px-1">Aggregates</span>`);

    aggregatesDiv.on("click", ".nama-aggregate-item", (e) => {
        let selectedItem = $(e.target).closest(".nama-aggregate-item");
        if (selectedItem.is(".nama-aggregate-item")) {
            setColAggregates(selectedItem, field, container, that.owner, columns, suffix, grid);
            popup.close();
        }
    });
    if (!container.find(".k-stick").length) {
        $(`<div class="k-columnmenu-item k-stick ${getColLocked(that.owner, toNormalId(e.field)) ? "k-disabled" : ""}"" tabindex="0"><span class="k-svg-icon k-svg-i-stick" aria-hidden="true"><svg viewBox="0 0 512 512" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M192 96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v32h128V96zm128 160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-96H64v96c0 106 86 192 192 192s192-86 192-192v-96H320v96zm96-192h-64c-17.7 0-32 14.3-32 32v32h128V96c0-17.7-14.3-32-32-32z"></path></svg></span>Stick Column</div>
                    <div class="k-columnmenu-item k-unstick ${getColLocked(that.owner, toNormalId(e.field)) ? "" : "k-disabled"}" tabindex="0" aria-disabled="true"><span class="k-svg-icon k-svg-i-unstick" aria-hidden="true"><svg viewBox="0 0 512 512" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M290.6 131.4c12.4-12.4 12.4-32.6 0-45l-45-45c-12.4-12.4-32.6-12.4-45 0L178 63.8l90.1 90 22.5-22.4zM268.1 334c-24.9 24.9-65.2 24.9-90.1 0s-24.9-65.2 0-90.1l67.5-67.5-90-90.1L88 153.9C13.4 228.5 13.4 349.4 88 424s195.5 74.6 270.1 0l67.5-67.5-90-90.1-67.5 67.6zm202.6-67.5-45-45c-12.4-12.4-32.6-12.4-45 0L358.2 244l90 90 22.5-22.5c12.4-12.4 12.4-32.6 0-45z"></path></svg></span>Unstick Column</div>
`).prependTo(container.find(".k-column-menu-position"));
        container.find(".k-stick").click((e) => {
            that.lockGridColumn(field);
            container.find(".k-stick").addClass("k-disabled");
            container.find(".k-unstick").removeClass("k-disabled");
            popup.close();
        });
        container.find(".k-unstick").click((e) => {
            that.unlockGridColumn(field);
            container.find(".k-unstick").addClass("k-disabled");
            container.find(".k-stick").removeClass("k-disabled");
            popup.close();
        });

    }

    let colId = toNormalId(e.field);
    let fieldTooltips = fetchFieldTooltip(that.owner.entityType, undefined, colId);
    if (fieldTooltips && fieldTooltips.length) {
        let showTooltip = translateId("showTooltip");
        let fieldTooltip = $(`<div class='k-columnmenu-item-wrapper showFieldTooltip'>` +
            `<span>${showTooltip}</span></div>`);
        fieldTooltip.click((e) => {
            let selectedRows = that.findElement().find(".k-grid-content").find("table").find("tr.k-selected");
            if (!selectedRows || !selectedRows.length) {
                notifier.showError(translateId("pleaseSelectRows"));
                return;
            }
            let lineNum = $(selectedRows[0]).index();
            showTooltip_(that.owner.entityType, colId, lineNum, that.owner);
        });
        fieldTooltip.appendTo(container);
    }

    changePopupMenuNestedColText(e, columns);
    e.container.on("click", "[type='reset']", function (ev) {
        let filters = e.sender.dataSource.filter().filters;
        removeFiltersForId(filters, field);
        grid.dataSource.filter(filters);
    });
}

function removeFiltersForId(filters, field) {
    if (!filters || !filters.length)
        return;
    for (let i = filters.length - 1; i >= 0; i--) {
        let filter = filters[i];
        if (filter.field == field)
            filters.splice(i, 1);
        if (filter.filters)
            removeFiltersForId(filter.filters, field);
    }
}

export function updateDataSrcAggregates(columns, dataSource, owner) {
    let dsAggregate = [];
    let allColumns = columns.flatMap(c => c.columns ? c.columns : c);
    for (let col of allColumns) {
        let colAggregates_ = getColAggregates_(owner, col.id);
        if (!colAggregates_)
            continue;
        colAggregates_ = colAggregates_.split(",");
        for (let aggr of colAggregates_) {
            if (dsAggregate.filter(agg => (agg.field == col.field && agg.aggregate == aggr.toLowerCase())).length)
                continue;
            dsAggregate.push({field: col.field, aggregate: aggr.toLowerCase()});
        }
    }
    dataSource._aggregate = dsAggregate;
}

export function valueCalculatorForQuestionField(questionFieldEditor) {
    return (ref) => {
        let fields = questionFieldEditor.getQuestionFields().filter(field => field.id === ref);
        if (fields && fields.length)
            return fields[0].value;
        return "";
    };
}

export function disableOrEnableCell(cell, state) {
    let gridButtons = [...cell.find(".gridButton")];
    if (state.state === "Disabled") {
        cell.attr("readonly", true);
        if (gridButtons && gridButtons.length)
            gridButtons.forEach(btn => $(btn).addClass("k-disabled"));
    } else {
        cell.removeAttr("readonly");
        if (gridButtons && gridButtons.length)
            gridButtons.forEach(btn => $(btn).removeClass("k-disabled"));
    }
}

export function isEmptyGridDataItem(dataItem) {
    let realKeys = realLineKeys();
    let otherKeys = Object.keys(dataItem).removeAll(realKeys);
    for (let k of realKeys) {
        let modelIdKey = modelId(k);
        if (otherKeys.contains(modelIdKey))
            otherKeys.splice(otherKeys.indexOf(modelIdKey), 1);
    }
    if (otherKeys <= 0)
        return true;
    for (let k of otherKeys) {
        if (isNotEmptyOrNull(dataItem[k]))
            return false;
    }
    return true;
}

/**
 * @implements FieldsOwner
 */
export class NamaGridWidget extends BaseWidget {
    get isField() {
        return false;
    }

    get isGridWidget() {
        return true;
    }

    getColumns() {
        return this.grid.columns;
    }

    getSelectedIndex() {
        let that = this;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        return that._getRowIndex(dataItem.id);
    }

    getSelectedRow() {
        let that = this;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        return grid.dataItem(current.parent());
    }

    rootElement() {
        let that = this;
        if (that.popupEditor)
            return that.popupEditor.rootElement();
        return that.findElement();
    }

    getFieldValue(fieldId) {

    }

    get entityType() {
        return this.owner.entityType;
    }

    /**
     *
     * @param {string} id
     * @param {namaTypes.EditScreenGrid} grid
     * @param {ExtendedNamaMetadata} metaData
     * @param  {FieldsOwner} owner
     */
    constructor({id, grid, metaData, owner, hasSelectBox, gridHeader, groupNum, withoutEditLineCommand}) {
        super({id, owner})
        this.metaData = metaData;
        this.id = id;
        this.grid = grid;
        this.elementId = nextId();
        this.owner = owner;
        this._firstRead = true;
        this.hasSelectBox = hasSelectBox;
        this.gridHeader = gridHeader;
        this.withoutEditLineCommand = withoutEditLineCommand;
        let groupId = id || ("p" + owner.currentPageIndex + "g" + groupNum);
        if (this.gridHeader) {
            this.gridHeader.attr("id", groupId);
            setItemCollapseAttr(owner, this.gridHeader, groupId);
        }
        this.disabledColsMap = new Map();
    }

    createElement() {
        return $(`<div id="${this.elementId}" nid="${this.id}">`);
    }

    refCodeOrNameCol(columnId) {
        let that = this;
        if (!columnId.endsWith(".code") && !columnId.endsWith(".name"))
            return false;
        let refColId = columnId.substring(0, columnId.length - 5);
        let columnMetadata = findFieldMetadata(refColId, that.metaData);
        if (!columnMetadata)
            return false;
        if (columnMetadata.fieldType === FieldType.Genericreference || columnMetadata.fieldType === FieldType.Reference)
            return true;
        return false;
    }

    afterAttach() {
        let that = this;
        that.model = kendo.data.Model.define({id: "id"});
        /**
         * @type {kendo.ui.GridColumn[]}
         */
        let columns = [gridRowNumberColumn(that, that.owner, false, true)];
        //TODO remove notSticky when kendo fix the problem
        let selectFieldId = "select";
        columns.push({
            id: selectFieldId,
            selectable: true,
            width: getFirstNotEmptyObj(getColWidth(that.owner, selectFieldId), 40),
            sticky: true,
            stickable: true,
            hidden: !that.hasSelectBox,
            headerAttributes: {"class": "p-1 text-center checkbox-align nama-selectAll-header"},
            order: getColOrder(that.owner, selectFieldId) || 2,
            attributes: {"class": "p-1 text-center checkbox-align"}
        });
        let lastMergedColumn = {};

        let unifiedWidth = 100;
        let detailMetadata = findFieldMetadata(that.id, that.metaData)
        let i = columns.length + 1;
        for (let column of that.grid.columns) {
            let validId = "$" + column.id.replaceAll(".", "$");
            let columnMetadata = findFieldMetadata(column.id, that.metaData)
            let refColId = column.id.substring(0, column.id.length - 5);
            if (that.refCodeOrNameCol(column.id))
                columnMetadata = findFieldMetadata(refColId, that.metaData);
            let title = translateTitledId(that.owner.entityType, column);
            let columnTitle = title;
            let columnsToPushTo = columns;
            if (!columnMetadata)
                continue;
            if (!userCanViewField(that.owner.entityType, column.id))
                continue;
            if (!isFeatureEnabled(columnMetadata.relatedToFeature))
                continue;
            if (!isFeatureEnabled(columnMetadata.referencedEntityType))
                continue;
            let finalCalculatedWidth = column.width;
            if (column.width && isReferenceColumn(columnMetadata)) {
                let colWidth = parseInt(column.width.substring(0, column.width.length - 2));
                if (colWidth < unifiedWidthInEM())
                    finalCalculatedWidth = unifiedRefWidth;
            }
            if (title.contains("|")) {
                let mainHeader = null;
                [mainHeader, columnTitle] = title.split("|");

                if (mainHeader !== lastMergedColumn.title) {
                    lastMergedColumn = {
                        title: mainHeader,
                        id: refColId,
                        order: getColOrder(that.owner, refColId) || i,
                        headerAttributes: {"class": "nama-col-header", "title": mainHeader},
                        columns: []
                    }
                    columns.push(lastMergedColumn);
                }
                columnsToPushTo = lastMergedColumn.columns;
            }
            if (columnMetadata.fieldType === FieldType.Genericreference && !singleAllowedValuesForEntityTypes(columnMetadata)) {
                let colEntityTypeId = column.id + ".entityType";
                let entityTypeId = "$" + (colEntityTypeId.replaceAll(".", "$"));
                let refColId = column.id + ".ref";
                columnsToPushTo.push({
                    title: columnTitle,
                    order: getColOrder(that.owner, column.id) || i,
                    id: column.id,
                    stickable: true,
                    sticky: getColLocked(that.owner, column.id),
                    headerAttributes: {"class": "nama-col-header", "title": columnTitle},
                    columns: [{
                        id: colEntityTypeId,
                        field: entityTypeId,
                        stickable: true,
                        title: "entityType",
                        type: "text",
                        hidden: isColHidden(that.owner, colEntityTypeId, column),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, colEntityTypeId), "8em"),
                        headerTemplate: `<span id="${entityTypeId}" class="n-c-header">${translateId("entityType")}</span>`,
                        template: comboTemplate(columnMetadata.fieldId + ".entityType", getTrimmedId(columnMetadata, detailMetadata) + ".entityType"),
                        editor: comboColumnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata) + ".entityType", that, columnMetadata.fieldId + ".entityType"),
                        attributes: {"nama-col": entityTypeId, "fieldId": column.id, "fullTitle": title + "|" + translateId("entityType")},
                        headerAttributes: {"class": "nama-col-header", "title": translateId("entityType")}
                    }, {
                        id: refColId,
                        stickable: true,
                        field: validId,
                        title: columnTitle,
                        type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                        hidden: isColHidden(that.owner, refColId, column),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, refColId), finalCalculatedWidth, unifiedWidth),
                        headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                        template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        attributes: {"nama-col": validId, "fieldId": column.id, "fullTitle": title},
                        headerAttributes: {"class": "nama-col-header", "title": columnTitle}
                    }, that.codeColumn(column, unifiedWidth, columnTitle)]
                });
            } else if (columnMetadata.referencedEntityType && shouldShowImage(columnMetadata.referencedEntityType, ShowImageIn.GridSeparateColumn)) {
                columnsToPushTo.push({
                    title: columnTitle,
                    order: getColOrder(that.owner, column.id) || i,
                    stickable: true,
                    sticky: getColLocked(that.owner, column.id),
                    headerAttributes: {"class": "nama-col-header", "title": columnTitle},
                    columns: [{
                        field: validId,
                        id: column.id,
                        stickable: true,
                        type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                        width: getFirstNotEmptyObj(getColWidth(that.owner, column.id), finalCalculatedWidth, unifiedWidth),
                        hidden: isColHidden(that.owner, column.id, column),
                        headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                        template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                        attributes: {"nama-col": validId, "fieldId": column.id, "fullTitle": title},
                        headerAttributes: {"class": "nama-col-header", "title": columnTitle}
                    }, {
                        width: unifiedWidth,
                        stickable: true,
                        template: imgColumnTemplate(getTrimmedId(columnMetadata, detailMetadata)),
                        attributes: {"nama-col": validId, "class": "nama-col-header", "fieldId": column.id},
                    }, that.codeColumn(column, unifiedWidth, columnTitle)]
                })
            } else {
                columnsToPushTo.push({
                    id: column.id,
                    order: getColOrder(that.owner, column.id) || i,
                    sticky: getColLocked(that.owner, column.id),
                    stickable: true,
                    field: validId,
                    title: columnTitle,
                    type: namaTypeToKendoColumnType(columnMetadata.fieldType),
                    width: getFirstNotEmptyObj(getColWidth(that.owner, column.id), finalCalculatedWidth, unifiedWidth),
                    hidden: isColHidden(that.owner, column.id, column),
                    headerTemplate: `<span id="${validId}" class="n-c-header">${columnTitle}</span>`,
                    template: columnTemplate(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                    editor: columnEditor(columnMetadata, getTrimmedId(columnMetadata, detailMetadata), that, column.id),
                    attributes: {"nama-col": validId, "fieldId": column.id, "fullTitle": title},
                    headerAttributes: {"class": "nama-col-header", "title": columnTitle}
                });
                if (columnMetadata.fieldType === FieldType.Reference || columnMetadata.fieldType === FieldType.Genericreference)
                    columnsToPushTo.push(that.codeColumn(column, unifiedWidth, columnTitle));
                if (columnMetadata.fieldType === FieldType.Decimal || columnMetadata.fieldType === FieldType.Integer || columnMetadata.fieldType === FieldType.Long)
                    columnsToPushTo.push(that.numberColumn(column, unifiedWidth, columnTitle));
            }
            i++;
        }
        that.dataSource = new kendo.data.DataSource({
            transport: {
                read: (options) => {
                    that._readRows(options);
                },
                update: (options) => {
                    that.owner.setFieldValue(that.id, options.data.models);
                    that._readRows(options);
                },
                create: (options) => {
                    nextGUIDId().then((id) => {
                        options.success({id});
                        that._kendoGrid().dataSource.page(0);
                    }).catch((e) => options.error(e));
                },
                destroy: (options) => {
                    that._readRows(options);
                }
            },
            // autoSync: true,
            pageSize: getGridPageSize(),
            schema: {
                model: that.constructModel(columns),
                parse: function (data) {
                    for (let i = 0; i < data.length; i++) {
                        setDataItemValues(data[i], i, that._kendoGrid().columns, that.metaData, that.owner);
                    }
                    return data;
                }
            },
        });
        bindClickOnSelectAll(that.findElement());
        that.findElement().on("click", ".column-search-btn", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let ele = $(e.target).parent();
            let entityType = ele.attr("fieldEntityType");
            let columnId = ele.attr("columnId");
            if (that.closedCellOrGrid(columnId))
                return;
            if (!userCanSearch(entityType))
                return;
            createSearcherWindow(that, that.calcGenericRefEntityType(e, entityType), (record) => {
                that.refSelectionCallBack(columnId, record);
            }, BaseDispatcher.createSearchContextInfo(columnId, -1, this), undefined, undefined, undefined, columnId);
        });
        that.findElement().on("contextmenu", "td,th", (e) => {
            that.showCellFieldInfo(e);
        });
        that.findElement().on("click", ".column-go-to-button", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let ele = $(e.target).parent();
            let href = ele.attr("href");
            let fieldEntityType = ele.attr("fieldEntityType");
            let columnId = ele.attr("columnId");
            let current = that._kendoGrid().current();
            if (href && href.length) {
                if (!ClientCache.isOpenInPopup(columnId, that.owner.entityType)) {
                    window.open(href, "_blank");
                } else {
                    let id = ele.attr("refid");
                    ajaxJSONWithoutError(NamaURLS.FIND_BY_ID, {
                        id: id, entityType: fieldEntityType,
                        contextInfo: null
                    }, (ref) => {
                        new PopupQuickCreator(ref.data, null, null, that.owner.entityType, "", e).show();
                    });
                }
            } else {
                if (that.closedCellOrGrid(columnId))
                    return;
                let dataItem = that.currentDataItem();
                let rowIndex = that._getRowIndex();
                let columnMetadata = findFieldMetadata(columnId, that.metaData);
                /**
                 *
                 * @type {namaTypes.FieldActionContextInfo}
                 */
                let contextInfo = createQuickCreateContextInfo(that.owner.entityType, columnMetadata, columnId, rowIndex, that.owner);
                ajaxJSONWithoutWait(NamaURLS.CREATE_NEW, {
                    entityType: that.calcGenericRefEntityType(e, fieldEntityType)
                    , quickCreatorContextInfo: JSON.stringify(contextInfo)
                }, (result) => {
                    let newRecord = result.data;
                    new PopupQuickCreator(newRecord, contextInfo, (record) => {
                        that.updateInDataItem(dataItem, columnId, record, true);
                    }, null, null, e).show();
                });
            }
        });
        columns.sort((o1, o2) => namaCompare(o1.order, o2.order));
        let commands = [{
            name: "addLine",
            text: "",
            template: `<a id="addNewLine" class="gridBtn text-secondary k-button k-button-icontext" title=${translateId("addNewLine")} data-business-func="addNewLine"><i class="fa-solid fa-circle-plus"></i></a>`
        }, {
            name: "copyLine",
            text: "",
            template: `<a id="copyLine" class="gridBtn text-secondary k-button k-button-icontext" title=${translateId("copyLine")} data-business-func="copyLine"><i class="fa-solid fa-copy"></i></a>`
        },
            {
                name: "deleteLine",
                text: "",
                template: `<a id="deleteLine" class="gridBtn text-secondary k-button k-button-icontext"title=${translateId("deleteLine")} data-business-func="deleteLine"><i class="fa-solid fa-trash-can"></i></a>`
            }];
        if (isNullOrUndefined(that.withoutEditLineCommand))
            commands.push({
                name: "editCurrLine",
                text: "",
                template: `<a id="editLine" class="gridBtn text-secondary k-button k-button-icontext" title=${translateId("editLine")} data-business-func="editLine"><i class="fa-solid fa-pen"></i></a>`
            });
        let fieldTooltips = fetchFieldTooltip(that.owner.entityType, undefined, that.id);
        if (fieldTooltips && fieldTooltips.length) {
            commands.push({
                name: "showTooltip",
                text: "",
                template: `<a id="showLineTooltip" class="gridBtn text-secondary k-button k-button-icontext" title=${translateId("showTooltip")} data-business-func="showTooltip"><i class="fa-solid fa-circle-info"></i></a>`
            });
        }
        columns.push({
            command: commands,
            attributes: {"readonly": true},
            width: "180px"
        });
        let allColumns = columns.flatMap(c => c.columns ? c.columns : c);
        for (let col of allColumns) {
            let columnMetadata = findFieldMetadata(col.id, that.metaData);
            if (!columnMetadata)
                continue;
            if (shouldShowHelpMsgs()) {
                let headerTemplate = $(`<div><div><span id="${modelId(col.id)}" class="n-c-header">${col.title}<a href="#" title="${translateId("help")}" id="helpLink" class="k-icon k-i-help gridHelpLink">
                </a></span></div></div>`);
                col.headerTemplate = headerTemplate.html();
            }
            let colType = namaTypeToKendoColumnType(columnMetadata.fieldType);
            col.filterable = {
                ui: fetchFilteringUIFor(columnMetadata, that.owner.entityType),
                extra: colType === "boolean" ? false : true,
            };
            let idOfGroupedCol = fetchColId(col);
            col.groupFooterTemplate = gridGroupFooterTemp(idOfGroupedCol, "", that.owner, that.metaData);
            col.footerTemplate = gridGroupFooterTemp(idOfGroupedCol, "", that.owner, that.metaData);
            let colAggregates_ = getColAggregates_(that.owner, idOfGroupedCol);
            if (!colAggregates_) {
                col.aggregates = [];
            } else {
                let aggregates = colAggregates_.split(",");
                col.aggregates = aggregates.map(a => a.toLowerCase());
            }
        }
        columns.flatMap(c => c.columns ? c.columns : c).forEach(c => {
            if (c.id) {
                if (!c.attributes)
                    c.attributes = {};
                c.attributes["fieldId"] = c.id;
                c.attributes.style = (c.attributes.style ? (c.attributes.style + ";") : "") + fetchAndApplyStyle(that.owner.entityType, c.id);
            }
        });
        columns.push({
            id: "id",
            field: "id",
            width: 0,
            hidden: true
        });


        that.findElement().kendoGrid({
            mobile: isMobileDevice(),
            onKeys_Insert: (current, e) => {
                let grid = that._kendoGrid();
                if (e.ctrlKey) {
                    if (e.altKey) showMultiCopyDialog(grid, that); else {
                        appendRow(grid, false, that);
                        return true;
                    }
                } else if (e.shiftKey) {
                    copyLinesAction(grid, that, 1);
                    return true;
                }
                return false;
            },
            dataSource: that.dataSource,
            columns: columns,
            height: gridSizeToPixels(that.grid.gridSize),
            size: "small",
            excel: {
                fileName: translateId(that.entityType) + " - " + that.calcGridTitle() + ".xlsx"
            },
            excelExport: (e) => gridExcelExport(e, that.findElement().data("kendoGrid"), "", true),
            pageable: {
                pageSizes: [25, 50, 75, 100, "all"],
                position: "top",
                buttonCount: 5,
            },
            editable: {
                confirmation: false
            },
            navigatable: true,
            reorderable: !isMobileDevice(),
            filterable: true,
            filter: function (e) {
                startFilter(e, that.owner, "");
            },
            group: function (e) {
                startGrouping(e, that.owner, "");
            },
            autoBind: true,
            groupable: false,
            resizable: {rows: true, columns: true},
            columnMenu: {componentType: "modern"},
            allowCopy: true,
            width: "100%",
            noRecords: true,
            dataBinding: function () {
                that.record = (this.dataSource.page() - 1) * (isNaN(this.dataSource.pageSize()) ? 1 : this.dataSource.pageSize())
            }, dataBound: function () {
                if (that.addingMultiRefs || that.changingPage)
                    return;
                that._fixWidthsAccordingToHeader();
                disableColumnsIfNeeded(that);
                resizePagerToShowPageSize(that._kendoGrid().pager);
                that.focusFieldInAddedLineIfNeeded();
            },
            edit: function (e) {
                let readonlyCell = e.container.attr("readonly");
                let readonlyGrid = e.container.closest(".k-grid").attr("readonlyGrid");

                if (that.popupEditor || readonlyCell || readonlyGrid) {
                    this.closeCell();
                    disableOrEnableCell(e.container, {state: "Disabled"});
                } else {
                    e.container.addClass("cellInEdit");
                    setTimeout(function () {
                        let input = e.container.find("input");
                        let typedKeys = e.container.attr("typedKeys");
                        if (typedKeys)
                            input.val(typedKeys);
                        else
                            input.select();
                        e.preventDefault();
                    });
                }
            },
            cancel: function (e) {
                let curCell = that.findElement().find(".k-focus").closest("td");
                curCell.removeAttr("typedKeys");
            },
            columnResize: function (e) {
                setColWidth(that.owner, e);
            },
            columnStick: function (e) {
                setColLocked(that.owner, e, true);
            },
            columnUnstick: function (e) {
                setColLocked(that.owner, e, false);
            },
            columnShow: function (e) {
                setColHidden(that.owner, e, false);
            },
            columnHide: function (e) {
                setColHidden(that.owner, e, true);
            },
            columnReorder: function (e) {
                reorderColumns(that.owner, that.findElement().data("kendoGrid"));
            },
            columnMenuInit: function (e) {
                colMenuBuilder(e, that, columns, true, "", that.findElement().data("kendoGrid"));
            },
            navigate: function (e) {
                that.navigateEditorToCurrent();
            },
            beforeEdit: function (e) {
                if (that.popupEditor)
                    e.preventDefault();
            },
            extraOnKeyDown: (e) => that.handleExtraOnKeyDown(e, that._kendoGrid().current()),
            isRowUpEvent: (e) => isKeyEventForBusinessFunction(e, BusinessFunction.rowUp),
            isRowDownEvent: (e) => isKeyEventForBusinessFunction(e, BusinessFunction.rowDown),
        });
        let gridBar = $(GridToolbarTemplate());
        if (that.gridHeader) {
            that.gridHeader.find("span").text(ts.translateTitledId(that.owner.entityType, that.grid));
            that.gridHeader.find(".fa-angle-up").remove();
            gridBar.insertAfter(that.gridHeader.find("span").parent());
        }
        gridBar.closest(".border").addClass("details");
        that.attachIconsHandlers(gridBar);
        that.attachIconsHandlers(that.findElement());
        that.findElement().on("click", "#helpLink", (e) => {
            e.preventDefault();
            let modelId = $(e.target).parent().attr("id");
            /**
             *
             * @type {namaTypes.DTOHelpMessagesRequest}
             */
            let reqData = {
                fieldId: toNormalId(modelId),
                entityType: that.entityType
            };
            findHelpMsgAndShowIt(reqData);
        });
        that.findElement().on("click", "#autoFitAllColumns", (e) => {
            e.preventDefault();
            that._autoFitColumns(true)
        });
        that.findElement().on("dblclick", "td:has(.row-number)", (e) => {
            let currentRowIndex = that._kendoGrid().current().parent().index();
            showTooltip(that.owner.entityType, that.id, currentRowIndex, that.owner, that.id);
        });
    }

    focusFieldInAddedLineIfNeeded() {
        let that = this;
        if (busy()) {
            setTimeout(() => that.focusFieldInAddedLineIfNeeded(), 200);
            return;
        }
        if (that.fieldToFocusOn && !isNullOrUndefined(that.rowToFocusOn)) {
            gridFocusCell(that, that.rowToFocusOn, undefined, undefined, undefined, that.fieldToFocusOn);
            that.fieldToFocusOn = undefined;
            that.rowToFocusOn = undefined;
        }
    }

    constructModel(columns) {
        let that = this;
        let gridFields = {};
        columns.flatMap(c => c.columns ? c.columns : c).filter(c => {
            if (c.field && c.field.length)
                gridFields[c.field] = {type: that.calcFieldType(c)};
        });
        that.model = kendo.data.Model.define({id: "id", fields: gridFields});
        return that.model;
    }

    calcFieldType(col) {
        let that = this;
        let columnMetadata = findFieldMetadata(col.id, that.metaData);
        if (!columnMetadata)
            return "string";
        let type = columnMetadata.fieldType;
        if (type == FieldType.Decimal || type == FieldType.Integer || type == FieldType.Long)
            return "number";
        if (type == FieldType.Boolean)
            return "boolean";
        if (type == FieldType.Date || type == FieldType.Time || type == FieldType.DateAndTime)
            return "date";
        if (type == FieldType.Genericreference || type == FieldType.Reference)
            return "object";
        return "string";
    }

    attachIconsHandlers(element) {
        let that = this;
        let buttons = element.find("a");
        if (buttons.length) {
            for (let i = 0; i < buttons.length; i++) {
                let current = $(buttons[i]);
                if (current.attr("data-business-func"))
                    current.attr('title', ts.translateId(current.attr("data-business-func")));
            }
        }
        element.on("click", "#addNewLine", (e) => {
            that.addLine(e);
        });
        element.on("click", "#copyLine", (e) => {
            that.copyLine(e);
        });
        element.on("click", "#deleteLine", (e) => {
            that.deleteLine(e);
        });
        element.on("click", "#insertLine", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            appendRow(grid, false, that);
        });

        element.on("click", "#rowDown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let current = that._kendoGrid().current();
            that._kendoGrid()._moveDown(current, e.shiftKey, e.ctrlKey);
        });
        element.on("click", "#rowUp", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let current = that._kendoGrid().current();
            that._kendoGrid()._moveUp(current, e.shiftKey, e.ctrlKey);
        });
        element.on("click", "#editLine", (e) => {
            openGridLineEditor(that, e);
        });
        element.on("click", "#showLineTooltip", (e) => {
            let lineNum = $(e.currentTarget).closest("tr").index();
            showTooltip_(that.owner.entityType, that.id, lineNum, that.owner);
        });
        element.on("click", "#removeEditor", (e) => {
            e.preventDefault();
            e.stopPropagation();
            removeEditorPart(that, e);
        });
        element.on("click", "#excelExport", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            grid.showColumn("id");
            grid.saveAsExcel();
        });
        element.on("click", "#selectLines", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            let gridColumns = grid.columns.filter(c => c.id === "select");
            if (!gridColumns || !gridColumns.length)
                return;
            let col = gridColumns[0];
            if (col.hidden) {
                $(e.target).addClass("k-active");
                grid.showColumn(grid.columns.indexOf(col));
            } else {
                $(e.target).removeClass("k-active");
                grid.hideColumn(grid.columns.indexOf(col));
                updateCheckBoxes(false, element);
            }
        });
        element.on("click", "#multiCopy", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            showMultiCopyDialog(grid, that);
        });
        element.on("click", "#groupableGrid", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let grid = that._kendoGrid();
            let options = $.extend({}, grid.getOptions());
            if (options.groupable)
                options.groupable = false;
            else
                options.groupable = true;
            grid.setOptions(options);
        });
    }

    async refSelectionCallBack(columnId, record, item, lastRefInMultiSelect) {
        let that = this;
        that.settingRef = true;
        let dataItem = item || that.currentDataItem();
        that.updateInDataItem(dataItem, columnId, record, true, lastRefInMultiSelect);
    }

    codeColumn(column, unifiedWidth, columnTitle) {
        return {
            field: "$" + ((column.id + ".code").replaceAll(".", "$")),
            id: column.id,
            hidden: true,
            title: columnTitle,
            menu: false
        };
    }

    numberColumn(column, unifiedWidth, columnTitle) {
        return {
            field: "$" + ((column.id + ".unformatted").replaceAll(".", "$")),
            id: column.id,
            hidden: true,
            title: columnTitle,
            menu: false
        };
    }

    calcGridTitle() {
        let that = this;
        return that.grid.title ? translateNaMaText(that.grid.title) : translate(that.grid.fieldId, that.owner.entityType);
    }

    navigateEditorToCurrent() {
        let that = this;
        if (!that.popupEditor)
            return;
        let grid = that._kendoGrid();
        let current = grid.current();
        if(!current || !current.parent())
            return;
        let dataItem = grid.dataItem(current.parent());
        let rowIndex = current.parent().index();
        if (that.popupEditor.lineId !== dataItem.id)
            that.popupEditor.show(grid.dataItem(current.parent()), rowIndex);
    }

    lockGridColumn(field) {
        let that = this;
        that.findElement().data("kendoGrid").stickColumn(field);
    }

    unlockGridColumn(field) {
        let that = this;
        that.findElement().data("kendoGrid").unstickColumn(field);
    }

    addLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        appendRow(grid, true, that);
    }

    deleteLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        deleteRow(e, grid, that);
    }

    moreThanOneRowIsSelected() {
        return this._kendoGrid().table.find("tr.k-selected").length > 0;
    }

    copyLine(e) {
        e.preventDefault();
        e.stopPropagation();
        let that = this;
        let grid = that._kendoGrid();
        copyLinesAction(grid, that, 1);
    }

    showCellFieldInfo(e) {
        let that = this;
        let attributes = e.currentTarget.attributes;
        let columnId = undefined;
        if (attributes["fieldId"])
            columnId = attributes["fieldId"].value;
        if (attributes["data-field"])
            columnId = toNormalId(attributes["data-field"].value);
        if (!columnId)
            return;
        let windowForField = $("[infoForField='" + columnId + "']");
        if (windowForField.length)
            return;
        let columnMetadata = findFieldMetadata(columnId, that.metaData);
        let refTable = "";
        if (columnMetadata)
            refTable = columnMetadata.fieldType === FieldType.Genericreference ? toCSVLineWithSep(",", columnMetadata.allowedValues)
                : columnMetadata.referencedEntityType;
        showFieldInfoFor(that.entityType, columnId, refTable, e, that);
    }

    closedCellOrGrid(columnId) {
        let that = this;
        if (that.popupEditor)
            return true;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        let rowIndex = that._getRowIndex(dataItem.id);
        let cell = that.fetchCell(rowIndex, columnId);
        let readOnlyCell = cell.attr("readonly") === "true" || cell.attr("readonly") === "readonly";
        let readOnlyGrid = cell.closest(".k-grid").attr("readonlyGrid") === "true";
        return readOnlyCell || readOnlyGrid;
    }

    calcGenericRefEntityType(e, currentEntityType) {
        let that = this;
        let columnId = $(e.target).parent().attr("columnId");
        let columnMetadata = findFieldMetadata(columnId, that.metaData);
        if (!columnMetadata || columnMetadata.fieldType !== FieldType.Genericreference)
            return currentEntityType;
        let current = that._kendoGrid().current();
        let grid = that._kendoGrid();
        let dataItem = grid.dataItem(current.parent());
        currentEntityType = dataItem[modelId(columnId + ".entityType")];
        return calcReferenceEntityType(currentEntityType, columnMetadata);
    }

    async _readRows(options) {
        let that = this;
        let rows = that.owner.getFieldValue(that.id);
        if (isNullOrUndefined(rows)) {
            rows = [];
            that.owner.setFieldValue(that.id, rows);
        }
        if (!rows.length) {
            rows.push({id: await nextGUIDId()});
            that._kendoGrid().dataSource.page(0);
        }
        updateDataSrcAggregates(that._kendoGrid().columns, that._kendoGrid().dataSource, that.owner);
        options.success(rows);
        if (that._firstRead) {
            that._firstRead = false;
            setTimeout(() => {
                gridFocusCell(that, 0);
                let useDetailedGrid = localStorage.getItem(gridKey(that));
                if (useDetailedGrid == "true" || (useDetailedGrid != "false" && shouldUseDetailedGridsInMobile() && isMobileDevice()))
                    openGridLineEditor(that);
            }, 1000);
        }
    }

    _fixWidthsAccordingToHeader() {
        if (true)//todo: remove this method because it creates strange widths
            return;
        let that = this;
        if (!that._valueSet)
            return;
        let fixedWidthesToHeaderId = that.owner ? that.owner.entityType + CommonConstants.SEPARATOR : "";
        if (that.owner && that.owner.viewName_ && that.owner.viewName_())
            fixedWidthesToHeaderId += that.owner.viewName_() + CommonConstants.SEPARATOR;
        fixedWidthesToHeaderId += that.gridHeader.attr("id") + CommonConstants.SEPARATOR;
        if (localStorage.getItem(fixedWidthesToHeaderId))
            return;
        localStorage.setItem(fixedWidthesToHeaderId, true);
        let headers = that.findElement().find("span.n-c-header");
        let fieldsThatNeedChange = new Map();
        for (let i = 0; i < headers.length; i++) {
            let h = $(headers[i]);
            if (!h.parent().width())
                continue;
            let EXTRA_WIDTH = 35;
            if (h.width() + EXTRA_WIDTH > h.parent().width() && h.prop("id")) {
                fieldsThatNeedChange.set(h.prop("id"), h.width() + EXTRA_WIDTH);
            }
        }
        if (!fieldsThatNeedChange.size)
            return;
        let options = $.extend({}, that._kendoGrid().getOptions());
        let optionColumnsMap = new Map();
        traverseColumns(optionColumnsMap, options.columns);
        for (let [field, newWidth] of fieldsThatNeedChange.entries()) {
            let c = optionColumnsMap.get(field);
            if (c)
                c.width = newWidth;
        }
        setTimeout(() => {
            that._kendoGrid().setOptions(options);
            that._kendoGrid().resize();
        });
    }

    _autoFitColumns(allColumns) {
        if (allColumns)
            addWait();
        let that = this;
        let headers = that.findElement().find("span.n-c-header");
        for (let i = 0; i < headers.length; i++) {
            let h = $(headers[i]);
            if (allColumns || h.width() > h.parent().width())
                that._kendoGrid().autoFitColumn(h.prop("id"))
        }
        if (allColumns)
            removeWait();
    }

    setValue(value, colId, rowIndex) {
        let that = this;
        try {
            that.settingValue = true;
            that._valueSet = true;
            let grid = that._kendoGrid();
            if (!grid)
                return;
            if (colId === that.id || !colId) {
                grid.dataSource.read();
                return;
            }

            if (noRowIndex(rowIndex)) {
                for (let i = 0; i < grid.dataSource.data().length; i++) {
                    let dataItem = grid.dataSource.data()[i];
                    that.updateInDataItem(dataItem, colId, that.owner.getFieldValue(colId, i))
                }
            } else {
                let changedItem = grid.dataSource.data()[rowIndex];
                if (changedItem)
                    that.updateInDataItem(changedItem, colId, that.owner.getFieldValue(colId, rowIndex))
            }
        } finally {
            that.settingValue = false;
        }
    }

    /**
     *
     * @private
     * @return {kendo.ui.Grid}
     */
    _kendoGrid() {
        return this.findElement().data("kendoGrid");
    }

    /**
     *
     * @private
     * @return {kendo.ui.Grid}
     */
    kendoGrid() {
        return this._kendoGrid();
    }

    shouldAddBlurHandler() {
        return false;
    }

    updateInDataItem(dataItem, fieldId, fieldValue, forceRefresh, settingLastRef) {
        if (!dataItem)
            return;
        let that = this;
        let trimmedId = fieldId.substring(that.id.length + 1, fieldId.length);
        if (that.settingValue) {
            setFieldValue(dataItem, trimmedId, fieldValue);
            dataItemSetterCallback(trimmedId, that, dataItem, fieldValue);
            if (forceRefresh)
                that._kendoGrid().refresh();
            return;
        }
        dataItemSetterCallback(trimmedId, that, dataItem, fieldValue);
        let rowId = dataItem["id"];
        that.onColumnChanged(trimmedId, fieldValue, rowId, settingLastRef);
        if (forceRefresh)
            that._kendoGrid().refresh();
    }

    onDataChanged(fieldId, fieldValue, options) {
        let that = this;
        that.updateInDataItem(options.model, fieldId, fieldValue, true);
        let rowId = options.model["id"];
        let rowIndex = that._getRowIndex(rowId);
        if (that.popupEditor)
            that.popupEditor.updatePopupEditWidgetsValues(rowIndex);
    }

    onColumnChanged(trimmedId, value, rowId, lastRefInMultiSelect) {
        let that = this;
        let detail = that._getRow(rowId);
        setFieldValue(detail, trimmedId, value);
        let rowIndex = that._getRowIndex(rowId);
        let colId = that.id + "." + trimmedId;
        that.removeErrorMarkerAndTooltip(rowIndex, that.id + "." + trimmedId)
        performPostAction(that.owner, colId, value, rowIndex, that, lastRefInMultiSelect);

    }

    fetchExtraCriteria() {
        let that = this;
        let questionListWidget = that.owner;
        if (!(questionListWidget instanceof QuestionListWidget))
            return that.extraCriteria;
        let questionFieldEditor = null;
        if (questionListWidget.owner && (questionListWidget.owner instanceof QuestionFieldsEditor))
            questionFieldEditor = questionListWidget.owner;
        return defaultCriteriaForFilterField(questionListWidget.questionField, that.entityType, valueCalculatorForQuestionField(questionFieldEditor));
    }

    _getRowIndex(rowId) {
        let that = this;
        if (!rowId) {
            let dataItem = that.currentDataItem();
            if (!dataItem)
                return -1;
            rowId = dataItem.get("id");
        }
        let details = that.owner.getFieldValue(that.id);
        for (let i = 0; i < details.length; i++) {
            if (details[i].id === rowId) {
                return i;
            }
        }
    }

    _getRow(rowId) {
        let details = this.owner.getFieldValue(this.id);
        for (let i = 0; i < details.length; i++) {
            if (details[i].id === rowId) {
                return details[i]
            }
        }
    }

    getPlaceExtraFieldFilterId() {
        return this.owner.getPlaceExtraFieldFilterId();
    }

    /**
     *
     * @param {namaTypes.EditScreenGrid} grid
     * @param {namaTypes.NaMaMetaData}
     */
    static hasColumns(grid, metaData, presenter) {
        for (let column of grid.columns) {
            let columnMetadata = findFieldMetadata(column.id, metaData)
            if (!columnMetadata)
                continue;
            if (!userCanViewField(presenter.entityType, column.id))
                continue;
            if (!isFeatureEnabled(columnMetadata.relatedToFeature))
                continue;
            return true;
        }
        return false;
    }

    updatePrevalidationState(state, objectIndex) {
        let that = this;
        if (objectIndex >= 0)
            that.addToDisabledColsMap(state, objectIndex);
        if (objectIndex === -1) {
            let grid = this._kendoGrid();
            let data = grid.dataSource.data();
            let length = data && data.length ? data.length : 1;
            for (let i = 0; i < length; i++) {
                that.updatePrevalidationState(state, i);
            }
            return;
        }
        if (that.popupEditor) {
            that.popupEditor.updatePopupEditWidgetsState(state);
            return;
        }
        let cell = that.fetchCell(objectIndex, state.fieldId);
        if (!cell)
            return;
        disableOrEnableCell(cell, state);
    }

    addToDisabledColsMap(state, objectIndex) {
        let that = this;
        let fieldId = state.fieldId;
        let grid = that._kendoGrid();
        let data = grid.dataSource.data();
        let rowId = data[objectIndex]["id"];
        let colList = that.disabledColsMap.get(rowId);
        if (!colList)
            that.disabledColsMap.set(rowId, []);
        if (state.state === "Disabled") {
            that.disabledColsMap.get(rowId).push(fieldId);
        } else {
            let fieldIdIndex = that.disabledColsMap.get(rowId).indexOf(fieldId);
            if (fieldIdIndex >= 0)
                that.disabledColsMap.get(rowId).splice(fieldIdIndex, 1);
        }
    }

    fetchCell(rowIndex, fieldId) {
        let grid = this._kendoGrid();
        let data = grid.dataSource.data();
        let dataItem = data[rowIndex];
        if (!dataItem)
            return;
        let row = grid.tbody.find("tr[data-uid=" + dataItem.uid + "]");
        let cell = row.find("td[nama-col='" + modelId(fieldId) + "']");
        if (!cell || !cell.length)
            cell = row.find("td[fieldId='" + fieldId + "']:visible");
        return cell;
    }

    elementToHighlight() {
        return this.findElement().find(".k-grid-header");
    }

    async appendEmptyRows(rowsCount, insertAfterIndex, insertAtEnd, doNotIgnoreEmptyLine) {
        let that = this;
        that.addingEmptyLines = true;
        let grid = that._kendoGrid();
        let current = 0;
        let cb = () => {
            if (current >= rowsCount) {
                that.addingEmptyLines = false;
                return;
            }
            if (!busy()) {
                appendRow(grid, insertAtEnd, that, !doNotIgnoreEmptyLine, undefined, undefined, insertAfterIndex);
                current++;
            }
            setTimeout(cb, 25);
        };
        setTimeout(cb, 25);
    }

    containsColumn(columnId) {
        let that = this;
        let columns = that.getColumns();
        if (columns) {
            for (let col of columns)
                if (col.id === columnId || that.genReferenceEntityTypeCol(columnId, col))
                    return true;
        }
        return false;
    }

    genReferenceEntityTypeCol(columnId, srcCol) {
        let that = this;
        if (srcCol.id + ".entityType" === columnId) {
            let columnMetadata = findFieldMetadata(srcCol.id, that.metaData);
            if (columnMetadata.fieldType === FieldType.Genericreference)
                return true;
        }
        return false;
    }

    isGenReferenceEntityTypeCol(columnId) {
        let that = this;
        let columns = that.getColumns();
        if (columns) {
            for (let col of columns) {
                if (that.genReferenceEntityTypeCol(columnId, col))
                    return true;
            }
        }
        return false;
    }

    isDeleteRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTInsertOrDeleteLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode, GridAction.DeleteLine);

    }

    dispatchCanAppendOrDeleteRow() {
        let presenter = this.owner;
        return !presenter.isViewOnlyMode();
    }

    canDeleteRow() {
        let that = this;
        if (that.questionList)
            return true;
        let notEditableGrid = that.findElement().attr("readonlyGrid");
        if (notEditableGrid)
            return false;
        if (that.isDeleteRowDisabled())
            return false;
        if (!that.dispatchCanAppendOrDeleteRow())
            return false;
        return true;
    }

    canAppendRow() {
        let that = this;
        if (that.questionList)
            return true;
        let notEditableGrid = that.findElement().attr("readonlyGrid");
        if (notEditableGrid)
            return false;
        if (that.isAppendRowDisabled())
            return false;
        if (!that.dispatchCanAppendOrDeleteRow())
            return false;
        return true;
    }

    isLastLineEmpty() {
        let data = this._kendoGrid().dataSource.data();
        if (!data || !data.length)
            return false;
        return isEmptyGridDataItem(data[data.length - 1]);
    }

    isAppendRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTInsertOrDeleteLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode, GridAction.InsertLine);

    }

    isCopyRowDisabled() {
        let that = this;
        let presenter = that.owner;
        return userCanNOTCopyLine(presenter.entityType, that.id, isInNewMode(presenter) ? ApplicableWhen.NewMode : ApplicableWhen.UpdateMode);

    }

    setEnabled(enabled) {
        let that = this;
        if (enabled === "Enabled" || enabled === true) {
            that.findElement().removeAttr("readonlyGrid");
            [...that.findElement().parent().parent().find(".icons").find("a")].forEach(btn => $(btn).removeClass("k-disabled"));
            [...that.findElement().find(".gridBtn")].forEach(btn => $(btn).removeClass("k-disabled"));
            [...that.findElement().find(".gridButton")].forEach(btn => $(btn).removeClass("k-disabled"));
        } else {
            that.findElement().attr("readonlyGrid", true);
            [...that.findElement().parent().parent().find(".icons").find("a")].forEach(btn => $(btn).addClass("k-disabled"));
            [...that.findElement().find(".gridBtn")].forEach(btn => $(btn).addClass("k-disabled"));
            [...that.findElement().find(".gridButton")].forEach(btn => $(btn).addClass("k-disabled"));
        }
    }

    removeErrorMarkerAndTooltip(rowIndex, fieldId) {
        let that = this;
        if (noRowIndex(rowIndex) || !fieldId)
            return;
        let cell = that.fetchCell(rowIndex, fieldId);
        cell.removeClass("invalidCell");
        cell.removeClass("k-tooltip");
    }

    afterAddingToGridAction(widget, options, trimmedFieldId, container) {
        if (container instanceof NamaGridLineEditor) {
            let colById = container.findColById(widget.id);
            let title = colById ? colById.title : colById.id;
            container.addWidget(widget);
            container.group.groupHandler.addWidget({
                id: widget.id,
                customFieldTitle: title
            }, {owner: {ownerId: this.entityType}}, null, {}, null, 1, widget);
        } else {
            widget.insideGrid = true;
            widget.render().appendTo(container);
            widget.afterAttach();
            if (widget instanceof ReferenceWidget)
                setTimeout(() => {
                    widget.setValue(fieldValue(options.model, trimmedFieldId))
                }, 100);
            else
                widget.setValue(fieldValue(options.model, trimmedFieldId));
        }

    }

    allColumnsAreReadOnly(rowIndex) {
        let that = this;
        let columns = that._kendoGrid().columns.flatMap(c => c.columns ? c.columns : c).filter(c => c.id && !c.hidden && (!c.editable || (c.editable && c.editable() === true)))
        for (let c of columns) {
            let cell = that.fetchCell(rowIndex, c.id);
            let readOnlyCell = cell.attr("readonly");
            if (readOnlyCell === undefined || readOnlyCell === false)
                return false;
        }
        return true;
    }

    currentDataItem() {
        let that = this;
        let current = that._kendoGrid().current();
        if (!current)
            return null;
        let grid = that._kendoGrid();
        let dataItem = fetchGridCurrentDataItem(grid);
        if (dataItem)
            return dataItem;
        if (that.popupEditor)
            return that.popupEditor.currentDataItem;
    }

    focusColumnInLastRow(focusFieldAfterAutoSave) {
        let that = this;
        gridFocusCell(that, ":last", undefined, undefined, undefined, focusFieldAfterAutoSave);
    }

    handleExtraOnKeyDown(e, current) {
        let that = this;
        let target = $(e.target);
        let handled = false;
        let keys = kendo.keys;
        if (e.keyCode === keys.F2)
            handled = that._handleF2Key(e, current, target);
        if (e.keyCode === keys.DELETE && e.ctrlKey)
            handled = that._handleDeleteKey(current);
        if (e.keyCode === KeyboardKeyCode.F6)
            handled = that._handleF6Key(current, e);
        if (e.keyCode === keys.INSERT)
            handled = that._handleInsertKey(current, e);
        if (isKeyEventForBusinessFunction(e, BusinessFunction.rowAppend))
            handled = that._handleAppendRow(current);
        if (letterORNumberKeyPressed(e))
            handled = that._handleLettersWriting(current, e);
        if (e.keyCode === 120)
            handled = that._handleShowTooltip(current, e);
        return handled;
    }

    _handleDeleteKey(current) {
        current.parent().find("#deleteLine").trigger("click");
        return true;
    }

    _handleF6Key(current, e) {
        if (this.popupEditor)
            this.popupEditor.removeEditorPart();
        else
            openGridLineEditor(this);
        return true;
    }

    _handleInsertKey(current, e) {
        let that = this;
        let grid = that._kendoGrid();
        if (e.altKey) {
            showMultiCopyDialog(grid, that)
            return true;
        } else if (e.ctrlKey) {
            appendRow(grid, false, that);
            return true;
        } else if (e.shiftKey) {
            copyLinesAction(grid, that, 1);
            return true;
        }
        return false;
    }

    _handleAppendRow(current) {
        if (current.parent().find("#addNewLine").length) {
            current.parent().find("#addNewLine").trigger("click");
            return true;
        }
        return false;
    }

    _handleLettersWriting(current, e) {
        if (this._kendoGrid().getOptions().editable === false)
            return false;
        if (current.hasClass("cellInEdit"))
            return false;
        current.attr("typedKeys", e.key);
        this._kendoGrid().editCell(current);
        return true;
    }

    _handleShowTooltip(current, e) {
        let that = this;
        let grid = that._kendoGrid();
        let currentRowIndex = grid.current().parent().index();
        let colModelId = grid.current().attr("nama-col");
        let colId = that.id;
        if (colModelId) colId = colModelId.substring(1, colModelId.length).replaceAll("$", ".")
        showTooltip(that.owner.entityType, colId, currentRowIndex, that.owner, that.id);
        return true;
    }

    _handleF2Key(e, cell, target) {
        if (this._kendoGrid().getOptions().editable === false)
            return false;
        e.preventDefault();
        e.stopPropagation();
        if (cell.hasClass("cellInEdit")) {
            cell.removeClass("cellInEdit");
            return this._kendoGrid()._handleEnterKey(cell, e.currentTarget, target);
        } else {
            cell.addClass("cellInEdit");
            this._kendoGrid().editCell(cell);
        }
        return true;
    }
}

function traverseColumns(map, columns) {
    for (let column of columns) {
        if (column.columns && column.columns.length)
            traverseColumns(map, column.columns);
        else
            map.set(column.field, column);
    }
}

/**
 *
 * @param {ExtendedFieldMetaData|string} subField
 * @param {ExtendedFieldMetaData|string} detailField
 * @return {string}
 */
export function getTrimmedId(subField, detailField) {
    let subFieldId = subField.fieldId ? subField.fieldId : subField;
    let detailFieldId = detailField.fieldId ? detailField.fieldId : detailField;
    return subFieldId.substring(detailFieldId.length + 1);
}

export function modelId(fieldId) {
    return "$" + fieldId.replaceAll(".", "$")
}

export function singleAllowedValuesForEntityTypes(columnMetadata) {
    if (!columnMetadata)
        return false;
    if (!columnMetadata.allowedValues)
        return false;
    return columnMetadata.allowedValues.length === 1;
}

export function isColHidden(owner, fieldId, column) {
    if (getColHidden(owner, fieldId) === "true")
        return true;
    return column ? column.showInGridView === false : false;
}

export function noRowIndex(rowIndex) {
    return rowIndex === undefined || rowIndex === null || rowIndex === -1;
}

export function setDataItemValues(item, rowIndex, gridColumns, metaData, owner, suffix) {
    if (!suffix)
        suffix = "";
    let columns = gridColumns.flatMap(c => c.columns ? c.columns : c).filter(c => !isNullOrUndefined(c.field))
    for (let col of columns) {
        let columnMetadata = findFieldMetadata(col.id, metaData);
        if (!columnMetadata)
            continue;
        let value = owner ? owner.getFieldValue(col.id, rowIndex) : item.values[col.id];
        if (!value)
            continue;
        let field = modelId(col.id);
        let dateCol = columnMetadata.fieldType === types.Date || columnMetadata.fieldType === types.DateAndTime || columnMetadata.fieldType === types.Time;
        let numberCol = columnMetadata.fieldType === types.Decimal || columnMetadata.fieldType === types.Long || columnMetadata.fieldType === types.Integer;
        if (columnMetadata.fieldType === types.ID) {
            item["$code" + suffix] = owner ? owner.getFieldValue("code", rowIndex) : item.values["code"];
            item["$altCode" + suffix] = owner ? owner.getFieldValue("altCode", rowIndex) : item.values["altCode"];
            item["$name1" + suffix] = owner ? owner.getFieldValue("name1", rowIndex) : item.values["name1"];
            item["$name2" + suffix] = owner ? owner.getFieldValue("name2", rowIndex) : item.values["name2"];
        }
        if (columnMetadata.fieldType === types.Reference || columnMetadata.fieldType === types.Genericreference) {
            if (value.id) {
                item[field + "$dashedId" + suffix] = value.id;
                item[field + "$nonDashedId" + suffix] = value.id.replaceAll("-", "");
                item[field + "$normalId" + suffix] = "0x" + value.id;
            }
            if (value.code)
                item[field + "$code" + suffix] = value.code;
            if (value.entityType)
                item[field + "$entityType" + suffix] = value.entityType;
            if (value.altCode)
                item[field + "$altCode" + suffix] = value.altCode;
            if (value.name1)
                item[field + "$name1" + suffix] = value.name1;
            if (value.name2)
                item[field + "$name2" + suffix] = value.name2;
        } else if (numberCol) {
            item[field + "$unformatted" + suffix] = value;
        }
        item[field + suffix] = value;
        if (dateCol) {
            item[field + suffix] = new Date(value);
        }
    }
}